declare const window: { env: any };

const config = Object.freeze({
  // We should use "/" as SERVER_BASE_URL in the local environment,
  // but in case we forget to configure the environment variable (env) during deployment,
  // we will use "/vlsoo-oo-member-portal" as the default.
  BACKEND_SERVER_URL: window.env?.BACKEND_URL || process.env.REACT_APP_BACKEND_URL || "http://localhost:8080/api",
  // Notification configuration
  NOTIFICATIONS: {
    en: (window.env?.NOTIFICATIONS_EN || process.env.REACT_APP_NOTIFICATIONS_EN)
      ? JSON.parse(window.env?.NOTIFICATIONS_EN || process.env.REACT_APP_NOTIFICATIONS_EN)
      : ['Default English Notification'],
    zh: (window.env?.NOTIFICATIONS_ZH || process.env.REACT_APP_NOTIFICATIONS_ZH)
      ? JSON.parse(window.env?.NOTIFICATIONS_ZH || process.env.REACT_APP_NOTIFICATIONS_ZH)
      : ['默認中文通知'],
  },
  VITE_AES_SECRET_KEY: window.env?.VITE_AES_SECRET_KEY || process.env.VITE_AES_SECRET_KEY,
  VITE_AES_IV: window.env?.VITE_AES_IV || process.env.VITE_AES_IV,
  VITE_RSA_PUBLIC_KEY: window.env?.VITE_RSA_PUBLIC_KEY,
  // Feature flag: show/hide the notification bar (default: true)
  SHOW_NOTIFICATION_BAR: (window.env?.SHOW_NOTIFICATION_BAR ?? process.env.REACT_APP_SHOW_NOTIFICATION_BAR ?? 'true') === 'true',
});

export default config;
